import { Component, Injector, inject as inject_1 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule, JkBaseOption, JkDialogEditComponent, jkRestReturn } from 'jk-service';
import { StkmeService, templateUrlConfigStk } from './../_service_stk';
import { Stkme } from '../_entity_stk';
import { JackBaseComponentModule } from 'jk-service';


@Component({
  selector: 'app-stkme-edit',
  templateUrl: templateUrlConfigStk.stkme,
  styleUrls: [],
  standalone: true,
  imports: [JackBaseComponentModule, MaterialModule,
  ],
})

export class StkmeEditComponent extends JkDialogEditComponent<StkmeService, Stkme> {
  override dialogRef: MatDialogRef<StkmeEditComponent>;
  override data: jkRestReturn;

  override srv!: StkmeService;
  constructor() {
    const inject = inject_1(Injector);
    const dialogRef = inject_1<MatDialogRef<StkmeEditComponent>>(MatDialogRef);
    const data = inject_1<jkRestReturn>(MAT_DIALOG_DATA);

    super(inject, dialogRef, data);
  
    this.dialogRef = dialogRef;
    this.data = data;
  }


}
